import { createAuthorizedGetRequest, createAuthorizedPostRequest, createAuthorizedPutRequest, decode, fetchApi, setBody } from '@/services/api';
import { pipe } from 'fp-ts/lib/function';
import { chain, map } from 'fp-ts/TaskEither';
import { listCodec } from '@/services/api/resources/chargebee/product/codec';

const plansUrl = '/v2/plans';
const hostedPageUrl = '/v2/hosted-page';
const checkoutUrl = '/v2/checkout';
const portalUrl = '/v2/portal';
const paymentSourceUrl = '/v2/payment-source';

export const list = () => pipe(
  plansUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(listCodec)),
);

export const createHostedPage = (planId: string, seatNumber: number, country: string) => pipe(
  hostedPageUrl,
  createAuthorizedPutRequest,
  map(setBody({ planId, seatNumber, country })),
  chain(fetchApi),
);

export const postHostedPage = (hostedPageId: string) => pipe(
  checkoutUrl,
  createAuthorizedPostRequest,
  map(setBody({ hostedPage: hostedPageId })),
  chain(fetchApi),
);

export const createPortal = () => pipe(
  portalUrl,
  createAuthorizedPostRequest,
  map(setBody({})),
  chain(fetchApi),
);

export const paymentSourceUpdated = () => pipe(
  paymentSourceUrl,
  createAuthorizedPutRequest,
  chain(fetchApi),
);
